<template>
  <div>
    <Label
      v-bind="labelProps"
      :html-for="id"
      :bold="labelBold"
      v-if="label"
      :disabled="disabled"
    >
      {{ label }}
    </Label>
    <b-input-group>
      <b-input-group-prepend>
        <Button
          type="success"
          labelSize="small"
          class="mr-0 p-3"
          :disabled="disabledChange"
          @click="changeType()"
          >{{ this.currentDiscount === this.VALUE ? 'R$' : '%' }}</Button
        >
      </b-input-group-prepend>
      <money
        :id="id"
        class="form-control input"
        :class="inputClass"
        :placeholder="placeholder"
        :disabled="disabled"
        :error="error"
        :maxlength="max"
        v-model="localValue"
        v-bind="formatOptions"
        @keydown.native="$event.key === '-' && $event.preventDefault()"
        @keyup.native="keyupHandler"
      />
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Label from './Label';
import Button from './Button';

export default {
  name: 'InputDiscount',
  components: {
    Label,
    Button,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
    label: {
      type: String,
      default: 'Desconto:',
    },
    labelProps: {
      type: Object,
    },
    labelBold: {
      type: Boolean,
      default: () => true,
    },
    value: {
      required: false,
      type: [Number, String],
      default: 0,
    },
    id: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    disabledChange: {
      type: Boolean,
      default: () => false,
    },
    onEnter: {
      type: Function,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => ({
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      }),
    },
    prefix: {
      type: Boolean,
      default: () => true,
    },
    precision: {
      type: Number,
    },
    max: {
      type: Number,
      default: () => null,
    },
    suffix: {
      type: String,
      default: () => null,
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      VALUE: 0,
      PERCENT: 1,
      discountType: null,
    };
  },
  computed: {
    ...mapGetters('purchase', ['decimalConfiguration']),

    currentDiscount() {
      return this.type;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (value !== this.value) {
          this.$emit('input', value);
          this.$emit('changeDiscount', this.currentDiscount);
        }
      },
    },
    inputClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },

    formatOptions() {
      return {
        ...this.options,
        prefix: this.prefix ? this.options.prefix : '',
        suffix: this.suffix || '',
        precision:
          this.precision ||
          this.decimalConfiguration.quantity ||
          this.options.precision,
      };
    },
  },
  mounted() {
    this.discountType = this.currentDiscount;
  },
  methods: {
    keyupHandler(params) {
      this.onKeyup(this.id, params);
    },
    changeType() {
      this.discountType =
        this.discountType === this.PERCENT ? this.VALUE : this.PERCENT;

      this.$emit('changeDiscount', this.discountType);
    },
  },
};
</script>
